module.exports = __webpack_public_path__ + "img/sliders_2-05.2904204f.png";